import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import 'react';
import { styled, css } from '@core-ui/react-stitch';
import Link from '@core-ui/link';
import { jsx } from '@emotion/react';
import HoverImageSwap from '@core-ui/hover-image-swap';
import { onPerceivedRender, reporting } from '@core-ui/reporting';

var LinkedCard = function LinkedCard(_ref) {
  var productUrl = _ref.productUrl,
      onClick = _ref.onClick,
      ariaHidden = _ref['aria-hidden'],
      children = _ref.children;
  return productUrl ? jsx(Link, {
    "aria-hidden": ariaHidden,
    onClick: onClick,
    to: productUrl
  }, children) : children;
};

var AthLogo = function AthLogo() {
  return jsx("svg", {
    viewBox: "0 0 260 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("rect", {
    fill: "#FFFFFF",
    height: "60",
    width: "260",
    x: "0",
    y: "0"
  }), jsx("path", {
    d: "M47.51 19.13l4.37-9.56 4.17 9.56zm-4.89 10.81l3.13-6.83h12l2.95 6.83h4.64L51.93.07 38.02 29.94zM71.82 1.83v3.99h6.46v24.12h4.24V5.82h6.45V1.83H71.82zM104.42 1.83h-4.25v28.11h4.25V16.81h12.12v13.13h4.24V1.83h-4.24v11h-12.12v-11zM134.94 1.83v28.11h12.5v-3.99h-8.26V1.83h-4.24zM174.4 1.83h-15.52v28.11h15.52v-3.99h-11.27v-9.39h10.94v-3.99h-10.94V5.82h11.27V1.83zM201.59 1.83h-17.15v3.99h6.46v24.12h4.24V5.82h6.45V1.83zM222.06 9.57l4.17 9.56h-8.54zm-9.26 20.37l3.13-6.83h12l2.95 6.83h4.64L222.11.07l-13.88 29.87zM15.23 15.11L12.7 23.8l-4.64 1.85 7.17-10.54-7.52 5-4.75-1.56 12.27-3.44-9-1L3.6 9.86l11.63 5.25-6.26-6.54.71-4.93 5.55 11.47-.6-9 3.73-3.32-3.13 12.32 5.35-7.3 5-.15-10.35 7.45 8.79-2.15 3.92 3.09-12.71-.94 8.12 4 1 4.89-9.12-8.89 3.65 8.29-2.36 4.39zm15.06.06a15.17 15.17 0 10-15.13 15.12 15.17 15.17 0 0015.17-15.16",
    fill: "#76777a",
    transform: "translate(10, 15)"
  }));
};

var BrfsLogo = function BrfsLogo() {
  return jsx("svg", {
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("defs", null, jsx("style", null, '.cls-3{clip - path:url(#clip-path);}')), jsx("rect", {
    fill: "#cccbcb",
    height: "800",
    width: "800"
  }), jsx("g", {
    className: "cls-3"
  }, jsx("path", {
    d: "M645.38,470.24c-26.82-27.68-51.43-74-70.12-105.63-14-24.64-33.69-45.83-71.48-47.81v-.38c44.38-5.16,95.87-38,95.87-85.54,0-71.07-83-92.86-142.11-92.86H297.6c-59.17,0-142,21.88-142,92.86,0,51.87,60.32,82.75,90.5,81.44V313c-57.19,0-113.7,34.27-113.7,87.3,0,67.36,49.31,93.69,163,93.69H456.8c-8.67-3.13-17.06-14.11-17.06-24.51V328.32h15.81c32.39,0,56.87,15.49,73.7,45.06,17.37,30.81,32.93,58.56,57.57,98,7.26,11.42,21.56,22.43,47.32,22.43h50a89.6,89.6,0,0,1-38.75-23.55m-330,.83H288c-62.85,0-110.24-20.19-110.24-71.55,0-51,46.15-71.2,110.24-71.2h27.33V471.07Zm0-166.53H311.3c-56.2,0-110.37-18.11-110.37-73.88,0-51.49,50.43-69.57,100.8-69.57h13.69l-.06,143.45Zm80.48,166.53H359.3V328.32h36.54Zm0-166.53H359.3V161.18h36.54Zm48.74,0h-4.8V161.18h13.63c50.37,0,100.8,18,100.8,69.57,0,49.41-44,73.79-109.63,73.79",
    fill: "#232020"
  })), jsx("path", {
    d: "M150,562.59h42.11V577.7H168.22v11.93h22.5v14.72h-22.5v27H150Z",
    fill: "#000100"
  }), jsx("path", {
    d: "M229.79,562.59h23.46L277,631.36H258.37L254.88,619H228.26l-3.56,12.32H206.05Zm21.15,43.11-7-22.69c-.32-1.06-1.06-4.16-2.31-9.25-1.25,5.09-2.11,8.19-2.4,9.25l-6.94,22.69Z",
    fill: "#000100"
  }), jsx("path", {
    d: "M345.18,585.79c-5-5.6-9.82-8.29-15.87-8.29-10.88,0-18.05,8.29-18.05,19.91,0,10.59,7.11,19.17,18.05,19.17,6.05,0,10.88-2.69,15.87-8.29V628.8a39.8,39.8,0,0,1-17.82,4.32c-20.29,0-34.91-15.3-34.91-36.06S307.07,561,327.36,561a39.9,39.9,0,0,1,17.82,4.32Z",
    fill: "#000100"
  }), jsx("path", {
    d: "m384.74 578.85h-15.3v-16.26h49.44v16.26h-15.39v52.54h-18.75v-52.54z",
    fill: "#000100"
  }), jsx("path", {
    d: "m499.81 622.62a37.31 37.31 0 0 1 -49.41 2.31 35.56 35.56 0 0 1 -2.59 -53.31 37.32 37.32 0 0 1 52 0 35.72 35.72 0 0 1 0 51zm-8.07-25.5c0-11.17-7.48-20.19-18-20.19s-18 8.93-18 20.19 7 20.22 18 20.22c10.71 0 18-8.96 18-20.22z",
    fill: "#000100"
  }), jsx("path", {
    d: "M535.78,562.59h20.76c9.51,0,16.8.1,22.69,4.64,5,3.84,7.68,9.73,7.68,16.83,0,10.66-5.37,17.51-15.36,19.62l18.75,27.68H569.15l-15.77-26.94v26.94h-17.6Zm21.05,32.55c7.91,0,11.65-2.5,11.65-8.58,0-7.23-3.55-9.54-11.36-9.54h-3.74V595.1h3.45Z",
    fill: "#000100"
  }), jsx("path", {
    d: "m623.26 600l-24.12-37.44h21.63l9.23 17.76a19.37 19.37 0 0 1 2.3 5.86 19.68 19.68 0 0 1 2.37 -5.86l9.15-17.73h21.54l-24 37.44v31.33h-18.1z",
    fill: "#000100"
  }));
};

var BrLogo = function BrLogo() {
  return jsx("svg", {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("g", {
    fill: "#231f20"
  }, jsx("path", {
    d: "m9.085 9.657h.972v3.815h-.972zm-4.235-2.61c0 1.49 1.449 1.98 2.949 1.98h.117v-3.837h-.371c-1.346 0-2.695.485-2.695 1.858zm-.618 4.513c0 1.372 1.267 1.912 2.948 1.912h.736v-3.815h-.736c-1.712 0-2.948.539-2.948 1.903zm10.059-4.513c0-1.373-1.348-1.858-2.695-1.858h-.364v3.839h.13c1.755 0 2.929-.659 2.929-1.98z"
  }), jsx("path", {
    d: "m0 0v20h20v-20zm16.428 14.083c-.695 0-1.072-.294-1.266-.601-.658-1.056-1.073-1.796-1.538-2.62-.448-.793-1.105-1.206-1.967-1.206h-.424v3.773c.017.287.193.54.456.654h-4.315c-3.04 0-4.355-.707-4.355-2.5 0-1.415 1.509-2.334 3.038-2.334v-.011c-.81.033-2.42-.79-2.42-2.175 0-1.903 2.223-2.485 3.798-2.485h4.273c1.58 0 3.798.582 3.798 2.484 0 1.266-1.378 2.145-2.563 2.282v.01c1.014.054 1.539.625 1.914 1.28.497.845 1.155 2.083 1.875 2.82.285.296.64.514 1.033.633z"
  }), jsx("path", {
    d: "m9.085 5.189h.972v3.836h-.972z"
  })));
};

var GapLogo = function GapLogo() {
  return jsx("svg", {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("g", {
    fill: "none",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M10 0H0v20h20V0z",
    fill: "#000D42"
  }), jsx("path", {
    d: "M5.787 10.603H6.2v2.772a.435.435 0 0 1-.429.447.425.425 0 0 1-.41-.447V6.863c0-.177.036-.596.34-.593.251 0 .426.232.505.58.089.525.135 1.056.137 1.588 0 .124.047.168.184.168h.295V6.16h-.241v.117c0 .124-.08.114-.143.073a1.4 1.4 0 0 0-.724-.26.908.908 0 0 0-.993.952V12.8c0 1 .536 1.184 1.057 1.19a1.27 1.27 0 0 0 .74-.288c.101-.051.184.076.184.225h.21v-3.324h.339v-.247H5.787v.247zm8.245-4.441h-1.403v.228h.368v7.093c0 .155-.067.212-.295.222h-.077v.197h1.588v-.197h-.165c-.267 0-.362-.118-.369-.35v-2.749h.46c.67 0 1.055-.317 1.055-.755V6.984c-.004-.435-.334-.822-1.162-.822zm.485 2.197v1.527a.435.435 0 0 1-.454.46h-.387V6.39h.353a.486.486 0 0 1 .485.499l.003 1.47zm-5.31 2l.368-3.115.419 3.115h-.788zm1.828 2.974l-.892-7.171h-.708l-.898 7.21c-.051.228-.054.288-.4.317v.222h1.107v-.197a.546.546 0 0 1-.355-.114.263.263 0 0 1-.057-.152l.336-2.858h.857l.353 2.839c0 .18-.02.247-.238.26h-.105v.197h1.41v-.197h-.039a.359.359 0 0 1-.371-.356z",
    fill: "#FFF"
  })));
};

var GapfsLogo = function GapfsLogo() {
  return jsx("svg", {
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("defs", null, jsx("style", null, '.cls-3{clip-path:url(#clip-path);}')), jsx("rect", {
    fill: "#000c41",
    height: "800",
    width: "800"
  }), jsx("g", {
    className: "cls-3"
  }, jsx("path", {
    d: "M592.86,150.21H526.69v6.3h17.44v374c-.45,8.13-3.2,11-14,11.39h-3.49v6.82h74.62V542h-7.87c-12.51-.57-17.12-6-17.38-18V373.6h21.76c31.62,0,49.8-16.61,49.8-38.82V192.32c-.13-22.18-15.68-42.11-54.76-42.11m22.82,191.87c.06,12.45-7.33,23.87-21.31,23.74H576.06V156.51h16.68c15.52,0,22.94,14.56,22.94,25.63V342.08Zm-164,181.76v.29l-42.18-374H381.25l-41,370c-2.44,13.25-3.62,21.41-22.88,21.82v6.88H367.2V542c-14,0-20.51-8.83-19.14-18.43l16.68-150h38.75l17.44,155.14c-.07,9.37-.93,12.7-11.3,13.44H404.8v6.88h66.27v-6.88h-1.76c-12.67-.74-16.86-9.35-17.63-18.21M365.44,366.43l17.44-160.54,19.74,160.54Z",
    fill: "#fff"
  })), jsx("g", {
    className: "cls-3"
  }, jsx("path", {
    d: "M242.62,155.33c0,6.33-3.74,5.92-6.75,3.81-10.81-7.49-24-13-35.81-12.74-19.2.06-46.81,9.34-46.88,49.63V492.29c.39,51.45,25.25,61,49.83,61.34,19.17.16,28.25-9.89,35.93-13.21,4.07-1.8,8.68,2.33,8.68,10h7.93V373.66h15.94v-7.32H204.16v7.32h19.49V524.1c0,13-8.93,23.13-20.35,23.13-11,0-19.33-10.24-19.33-23.13V184.26c0-9.16,1.76-30.76,16.06-30.63,11.87.07,20.07,11.91,23.87,30,4.07,18.88,6.5,64.54,6.5,83.61,0,6.43,2.08,8.67,8.67,8.67h12.61V150h-8.93v5.31Z",
    fill: "#fff"
  })), jsx("g", {
    className: "cls-3"
  }, jsx("path", {
    d: "M531.81,626H545.7c4.92,0,8.86,2.21,8.86,7.33s-2.82,7.87-8.06,7.87H531.81V626ZM514.3,679.1h17.51V654.62h13.25c8.19,0,9.31,7,9.76,13.8.25,2,.51,8.44,2,10.68h17.31c-2.37-2.43-2.62-12.35-2.91-15.16-.58-6.4-2.53-14.4-9.82-16.1v-.19c7.07-2.75,10.55-9.63,10.55-16.83,0-13.57-11.68-18.92-23.48-18.92H514.3v67.2Z",
    fill: "#fff"
  })), jsx("polygon", {
    fill: "#fff",
    points: "153.31 679.1 170.82 679.1 170.82 653.18 198.5 653.18 198.5 639.65 170.82 639.65 170.82 625.98 202.82 625.98 202.82 611.9 153.31 611.9"
  }), jsx("polygon", {
    fill: "#fff",
    points: "421.06 611.87 363.49 611.87 363.49 626.91 383.55 626.91 383.55 679.04 401.06 679.04 401.06 626.91 421.06 626.91"
  }), jsx("path", {
    d: "M208,679H226l4.35-12h23.33l4.13,12H276l-25.12-67.17H233.12Zm33.89-48.54h.29L249.5,654H234.24Z",
    fill: "#fff"
  }), jsx("g", {
    className: "cls-3"
  }, jsx("path", {
    d: "M348.45,634.5c-.51-16.23-16.19-25.41-30.69-25.41-20.32,0-33.5,15.49-33.5,35s13.18,35,33.5,35c17,0,29.86-10,30.69-27.36H330.94c-.67,7.62-5.37,12.42-13.56,12.42-11.33,0-15.62-10-15.62-20s4.42-19.93,15.62-19.93c7.32,0,12.64,3.58,13.56,10.36l17.51-.12Z",
    fill: "#fff"
  })), jsx("g", {
    className: "cls-3"
  }, jsx("path", {
    d: "m449.5 644.06c0-10 4.32-19.93 15.62-19.93s15.55 10 15.55 19.93-4.41 20-15.55 20c-11.3 0-15.62-10-15.62-20m-17.5 0c0 19.46 11.94 35 33.12 35s33.06-15.48 33.06-35c0-19.39-11.94-35-33.06-35s-33.12 15.61-33.12 35",
    fill: "#fff"
  })), jsx("polygon", {
    fill: "#fff",
    points: "650.24 611.9 630.37 611.9 617.06 639.23 603.68 611.9 583.81 611.9 608.32 654.02 608.32 679.1 625.82 679.1 625.82 654.02"
  }));
};

var OnLogo = function OnLogo() {
  return jsx("svg", {
    viewBox: "0 0 40 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, jsx("g", {
    fill: "none",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M19.999 13.714c5.268 0 10.227-.679 13.972-1.904C37.857 10.531 40 8.775 40 6.855c0-1.916-2.142-3.677-6.029-4.953C30.23.677 25.27 0 20 0 14.733 0 9.77.677 6.029 1.902 2.144 3.18 0 4.936 0 6.857c0 1.918 2.145 3.674 6.029 4.953 3.741 1.225 8.704 1.904 13.97 1.904",
    fill: "#FFF"
  }), jsx("path", {
    d: "M19.999 13.274c10.803 0 19.562-2.879 19.562-6.417C39.561 3.313 30.802.44 20 .44 9.198.44.44 3.314.44 6.857.445 10.401 9.197 13.274 20 13.274",
    fill: "#0F4879"
  }), jsx("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: ".2"
  }, jsx("path", {
    d: "M9.785 4.407h1.316V8.52h1.182v.883H9.785zM13.112 4.407h1.423c1.612 0 2.374.955 2.374 2.42 0 1.422-.621 2.573-2.215 2.573h-1.591l.009-4.993zm1.313 4.113h.146c.923 0 .923-1.08.923-1.738 0-.576-.087-1.492-.958-1.492h-.11v3.23zM18.777 4.407h1.212l1.505 3.108h.005V4.407h1.17v4.996h-1.17l-1.541-3.202h-.012v3.202h-1.169zM24.547 4.407h1.724L27.48 9.4H26.08l-.17-1.008h-1.022l-.167 1.013h-1.397l1.224-4.998zm.488 3.1h.723l-.34-2.032h-.047l-.336 2.032zM27.5 4.407h1.373l.478 2.872h.026l.481-2.872h1.374l-1.208 4.996h-1.319zM32.98 6.926l-1.294-2.52h1.293l.664 1.475.791-1.474h1.164l-1.296 2.519v2.477h-1.323zM7.006 4.31c-1.548 0-2.024 1.317-2.024 2.595 0 1.279.477 2.596 2.024 2.596 1.547 0 2.025-1.312 2.025-2.596C9.029 5.63 8.553 4.31 7.006 4.31m0 4.255c-.619 0-.807-.848-.807-1.666 0-.82.19-1.66.807-1.66.62 0 .811.84.811 1.66 0 .818-.192 1.666-.811 1.666"
  }))));
};

var _templateObject$3;

var Logo = function Logo(_ref) {
  var brand = _ref.brand;
  var BrandLogo = {
    AT: AthLogo,
    BR: BrLogo,
    BRFS: BrfsLogo,
    GAP: GapLogo,
    GAPFS: GapfsLogo,
    ON: OnLogo
  }[brand];
  var ProductImageLogo = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    ", "\n  "])), ['BRFS', 'BR', 'GAP', 'GAPFS'].includes(brand) ? 'width: 18.18%' : 'width: 36.36%');
  return jsx(ProductImageLogo, null, jsx(BrandLogo, null));
};

var _templateObject$2;
var BrandedCardWrapper = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n"])));

var BrandedCard = function BrandedCard(_ref) {
  var brand = _ref.brand,
      ariaHidden = _ref['aria-hidden'],
      children = _ref.children;
  return brand ? jsx(BrandedCardWrapper, {
    "aria-hidden": ariaHidden
  }, children, jsx(Logo, {
    brand: brand
  })) : children;
};

var _excluded$1 = ["src", "alt", "hoverSrc", "hoverAlt", "useRatio"];

var _templateObject$1;
var productImageRatio = 1.33267;
var imageStyles = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  width: 100%;\n  object-fit: cover;\n  display: block;\n"])));

var HoveredImage = function HoveredImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      hoverSrc = _ref.hoverSrc,
      hoverAlt = _ref.hoverAlt,
      _ref$useRatio = _ref.useRatio,
      useRatio = _ref$useRatio === void 0 ? true : _ref$useRatio,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);

  return hoverSrc ? jsx(HoverImageSwap, _extends({
    background: {
      src: src,
      alt: alt
    },
    backgroundHover: {
      src: hoverSrc,
      alt: hoverAlt
    },
    imageRatio: productImageRatio,
    useRatio: useRatio
  }, otherProps)) : jsx("img", _extends({
    alt: alt,
    css: imageStyles,
    src: src
  }, otherProps));
};

var cat1ImageLoaded = function cat1ImageLoaded(highPriorityEvents) {
  var cat1LoadedEvent = highPriorityEvents.find(function (_ref) {
    var name = _ref.name;
    return name === 'cat1ImageLoaded';
  });
  onPerceivedRender().then(function () {
    var _window$gap;

    // eslint-disable-next-line no-console
    console.timeStamp('Cat 1st img loaded');

    if (!((_window$gap = window.gap) !== null && _window$gap !== void 0 && _window$gap.isCat1ImageLoadedSent) && cat1LoadedEvent) {
      window.gap.isCat1ImageLoadedSent = true;
      reporting('cat1ImageLoaded', 'cat1ImageVersion', 'componentMode');
      cat1LoadedEvent.deferred.resolve('cat1ImageLoaded');
    }
  });
};

var _excluded = ["productUrl", "brand", "aria-hidden", "onClick", "children", "highPriorityEvents", "index"];

var _templateObject;
var catProductImageStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 0.5rem;\n"])));

var ProductImage = function ProductImage(_ref) {
  var productUrl = _ref.productUrl,
      brand = _ref.brand,
      _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      onClick = _ref.onClick,
      children = _ref.children,
      highPriorityEvents = _ref.highPriorityEvents,
      index = _ref.index,
      imageProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("div", {
    className: "cat_product-image",
    css: catProductImageStyle
  }, jsx(LinkedCard, {
    "aria-hidden": ariaHidden,
    onClick: onClick,
    productUrl: productUrl
  }, jsx(BrandedCard, {
    "aria-hidden": ariaHidden,
    brand: brand
  }, jsx(HoveredImage, _extends({}, imageProps, {
    onLoad: function onLoad() {
      return index === 1 ? cat1ImageLoaded(highPriorityEvents) : null;
    }
  })))), children);
};
var brands = ['AT', 'BRFS', 'BR', 'GAP', 'GAPFS', 'ON'];

export default ProductImage;
export { brands };
//# sourceMappingURL=product-image.esm.js.map
